// Withdrawal Type of Withdrawal Channel
const INTERNATIONALBANKTRANSFER = 2
const UNIONPAY = 4
const THAILANDBANKTRANSFER = 5
const MALAYSIABANKTRANSFER = 6
const FASAPAY = 7
const VIETNAMBANKTRANSFER = 8
const INDIABANKTRANSFER = 24
const SKRILL = 31
const NETELLER = 32
const SOUTHKOREABANKTRANSFER = 35
const BITWALLET = 37
const INDONESIABANKTRANSFER = 39
const PHILIPPINESBANKTRANSFER = 40
const SOUTHAFRICABANKTRANSFER = 42
const HONGKONGBANKTRANSFER = 49
const PERFECTMONEY = 61
const JAPANBANKTRANSFER = 62
const MEXICOBANKTRANSFER = 63
const BRAZILBANKTRANSFER = 64
const LOCALDEPOSITOR_BND = 65
const NIGERIABANKTRANSFER = 67
const COLOMBIABANKTRANSFER = 74
const USDTTRC20 = 86
const USDTERC20 = 87
const CHILEBANKTRANSFER = 88
const COLUMBIABANKTRANSFER = 89
const INTERAC = 99
const PIX = 100
const FXIR = 97
const NODAPAYMENT = 110
const USDT_BEP20 = 106
const UAEBANKTRANSFER = 108
const AIRTM = 109
const BKASH = 115
const NAGAD = 117
const ROCKET = 118
const TCPAY = 122

/** Channels that support more than 1 currency must be added to the MULTIPLE_CURRENCY_CHANNELS array
 * JPY : considered 1 currency, Do Not need to be added
 * USD, USC : considered 1 currency, Do Not need to be added
 * USD, JPY : considered More Than 1, Need to be added
 */
export const MULTIPLE_CURRENCY_CHANNELS = [SKRILL, NETELLER, PERFECTMONEY, BITWALLET, INTERNATIONALBANKTRANSFER]

export const CURRENCY_RESTRICTED_CHANNELS = [
  UNIONPAY,
  THAILANDBANKTRANSFER,
  MALAYSIABANKTRANSFER,
  FASAPAY,
  VIETNAMBANKTRANSFER,
  INDIABANKTRANSFER,
  SOUTHKOREABANKTRANSFER,
  INDONESIABANKTRANSFER,
  PHILIPPINESBANKTRANSFER,
  SOUTHAFRICABANKTRANSFER,
  HONGKONGBANKTRANSFER,
  PERFECTMONEY,
  JAPANBANKTRANSFER,
  MEXICOBANKTRANSFER,
  BRAZILBANKTRANSFER,
  PIX,
  COLOMBIABANKTRANSFER,
  USDTTRC20,
  USDTERC20,
  CHILEBANKTRANSFER,
  COLUMBIABANKTRANSFER,
  NIGERIABANKTRANSFER,
  SKRILL,
  NETELLER,
  BITWALLET,
  INTERAC,
  FXIR,
  NODAPAYMENT,
  INTERNATIONALBANKTRANSFER,
  UAEBANKTRANSFER,
  AIRTM,
  LOCALDEPOSITOR_BND,
  BKASH,
  USDT_BEP20,
  TCPAY,
  ROCKET,
  NAGAD,
]

export const CURRENCY_AVAILABLE_TYPES = {
  USD: [
    UNIONPAY,
    THAILANDBANKTRANSFER,
    MALAYSIABANKTRANSFER,
    FASAPAY,
    VIETNAMBANKTRANSFER,
    INDIABANKTRANSFER,
    SOUTHKOREABANKTRANSFER,
    INDONESIABANKTRANSFER,
    PHILIPPINESBANKTRANSFER,
    SOUTHAFRICABANKTRANSFER,
    HONGKONGBANKTRANSFER,
    PERFECTMONEY,
    JAPANBANKTRANSFER,
    MEXICOBANKTRANSFER,
    BRAZILBANKTRANSFER,
    PIX,
    COLOMBIABANKTRANSFER,
    USDTTRC20,
    USDTERC20,
    CHILEBANKTRANSFER,
    COLUMBIABANKTRANSFER,
    NIGERIABANKTRANSFER,
    BITWALLET,
    SKRILL,
    NETELLER,
    FXIR,
    INTERNATIONALBANKTRANSFER,
    UAEBANKTRANSFER,
    AIRTM,
    LOCALDEPOSITOR_BND,
    BKASH,
    USDT_BEP20,
    TCPAY,
    ROCKET,
    NAGAD,
  ],
  USC: [
    UNIONPAY,
    THAILANDBANKTRANSFER,
    MALAYSIABANKTRANSFER,
    FASAPAY,
    VIETNAMBANKTRANSFER,
    INDIABANKTRANSFER,
    SOUTHKOREABANKTRANSFER,
    INDONESIABANKTRANSFER,
    PHILIPPINESBANKTRANSFER,
    SOUTHAFRICABANKTRANSFER,
    HONGKONGBANKTRANSFER,
    PERFECTMONEY,
    JAPANBANKTRANSFER,
    MEXICOBANKTRANSFER,
    BRAZILBANKTRANSFER,
    PIX,
    COLOMBIABANKTRANSFER,
    USDTTRC20,
    USDTERC20,
    CHILEBANKTRANSFER,
    COLUMBIABANKTRANSFER,
    NIGERIABANKTRANSFER,
    BITWALLET,
    SKRILL,
    NETELLER,
    FXIR,
    INTERNATIONALBANKTRANSFER,
    UAEBANKTRANSFER,
    AIRTM,
    LOCALDEPOSITOR_BND,
    BKASH,
    USDT_BEP20,
    TCPAY,
    ROCKET,
    NAGAD,
  ],
  EUR: [PERFECTMONEY, SKRILL, NETELLER, INTERNATIONALBANKTRANSFER, NODAPAYMENT, USDT_BEP20, USDTTRC20, USDTERC20],
  HKD: [INTERNATIONALBANKTRANSFER, USDT_BEP20, USDTTRC20, USDTERC20, HONGKONGBANKTRANSFER],
  JPY: [JAPANBANKTRANSFER, BITWALLET, INTERNATIONALBANKTRANSFER, USDT_BEP20, USDTTRC20, USDTERC20],
  CAD: [INTERAC, SKRILL, INTERNATIONALBANKTRANSFER, USDT_BEP20, USDTTRC20, USDTERC20],
  GBP: [SKRILL, NETELLER, INTERNATIONALBANKTRANSFER, USDT_BEP20, USDTTRC20, USDTERC20],
  AUD: [NETELLER, SKRILL, INTERNATIONALBANKTRANSFER, USDT_BEP20, USDTTRC20, USDTERC20],
  SGD: [NETELLER, INTERNATIONALBANKTRANSFER, USDT_BEP20, USDTTRC20, USDTERC20],
  NZD: [USDT_BEP20, USDTTRC20, USDTERC20],
  UST: [USDT_BEP20, USDTTRC20, USDTERC20],
}
